import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-141776d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gd-documents mb-gutter" }
const _hoisted_2 = { class: "gd-form-part" }
const _hoisted_3 = { class: "mb-medium" }
const _hoisted_4 = { class: "mb-medium" }
const _hoisted_5 = { class: "form-field form-field--gd" }
const _hoisted_6 = { class: "field-row" }
const _hoisted_7 = {
  class: "label label--text label--inline",
  "data-auto": "documentproof-lbl"
}
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-field form-field--gd" }
const _hoisted_11 = { class: "field-row" }
const _hoisted_12 = {
  class: "label label--text label--inline",
  "data-auto": "choosefile-lbl"
}
const _hoisted_13 = { class: "gd-file-upload" }
const _hoisted_14 = { class: "gd-file-selector" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = {
  class: "font-small",
  "data-auto": "choosefiletext-lbl"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "gd-form-part top-padding" }
const _hoisted_19 = {
  key: 0,
  class: "success-text"
}
const _hoisted_20 = {
  key: 0,
  class: "gd-file-list font-small"
}
const _hoisted_21 = { class: "list-styled" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-field form-field--gd" }, null, -1))
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "form-field form-field--gd" }
const _hoisted_25 = { class: "field-row gd-form-declaration" }
const _hoisted_26 = { class: "form-field form-field--gd" }
const _hoisted_27 = { class: "field-row gd-form-declaration" }
const _hoisted_28 = { class: "gd-field__option" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_30 = {
  class: "label label--text label--inline label--multi-line no-padding",
  "data-auto": "Declaration-lbl"
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "form-field form-field--gd" }
const _hoisted_33 = { class: "field-row gd-form-declaration" }
const _hoisted_34 = { class: "form-field form-field--gd" }
const _hoisted_35 = { class: "field-row gd-form-declaration" }
const _hoisted_36 = { class: "form-field form-field--gd" }
const _hoisted_37 = { class: "field-row gd-form-declaration" }
const _hoisted_38 = { class: "gd-field__option" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_40 = {
  class: "label label--text label--inline label--multi-line no-padding",
  "data-auto": "ColleagueDeclaration-lbl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(`${_ctx.translate("labeltext.partC")}${_ctx.translate(
            "labeltext.formCompletionHeader"
          )}`), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("labeltext.formCompletionBody")), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labeltext.authThirdParty")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("labeltext.doctype")), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.initModel.selectedDocument) = $event)),
          name: "documentproof"
        }, [
          _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("labeltext.docTypeDefaultValue")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDropdownValues, (docType, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: docType.value,
              key: index
            }, _toDisplayString(_ctx.getTranslatedValue(`labeltext.${docType.resourceKeyVal}`)), 9, _hoisted_9))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.initModel.selectedDocument]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("labeltext.selectUpload")), 1),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, [
            _createElementVNode("input", {
              type: "file",
              name: "choosefile",
              ref: "fileupload",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileChange($event.target?.files)))
            }, null, 544),
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, [
              _createTextVNode(" ("),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedFileTypes, (ext, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, [
                  _createTextVNode("." + _toDisplayString(ext), 1),
                  (index !== _ctx.allowedFileTypes.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, ", "))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createTextVNode(") ")
            ])
          ]),
          _createElementVNode("button", {
            class: "button button--alt",
            id: "uploadfile",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
          }, _toDisplayString(_ctx.$t("labeltext.upload")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("h3", null, [
        (_ctx.showFileUploadSuccessMessage)
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("labeltext.fileUploadSuccessful")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.newUser.DocumentList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("labeltext.listUploadedFiles")), 1),
          _createElementVNode("ul", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newUser.DocumentList, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(index + 1) + ". " + _toDisplayString(_ctx.getSelectedDocName(item.DocumentTypeId)) + " - " + _toDisplayString(item.FileLocation), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("h3", null, _toDisplayString(`${_ctx.translate("labeltext.declarationHeader1")}${_ctx.translate(
            "labeltext.declarationHeader2"
          )}`), 1)
    ]),
    _hoisted_22,
    (_ctx.showDeclaration())
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("labeltext.declarationType1")), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", _hoisted_27, [
              _createElementVNode("span", _hoisted_28, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "Declaration",
                  value: "Declaration",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.initModel.Declaration) = $event)),
                  name: "tncdeclaration"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.initModel.Declaration]
                ]),
                _hoisted_29
              ]),
              _createTextVNode("   "),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("labeltext.declarationTextV2")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showColleagueDeclaration())
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("labeltext.declarationSubHeader1")), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("labeltext.declarationType2", {
              brandPlcName1: _ctx.initModel.brandPlcName,
            })), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("label", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "ColleagueDeclaration",
                  value: "ColleagueDeclaration",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.initModel.ColleagueDeclaration) = $event)),
                  name: "tnccolleaguedeclaration"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.initModel.ColleagueDeclaration]
                ]),
                _hoisted_39
              ]),
              _createTextVNode("   "),
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("labeltext.declarationtext2")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}